import { connectedStore } from '../../store';
import selectors from '../selectors';

const getPageTemplateId = (pageId) => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getPageTemplateId(state, pageId);
};

export default getPageTemplateId;
